import { CodeValidatedActionEnum } from '../enum/CodeValidatedActionEnum';
import { SmsCodeResponse } from '../structures/response/SmsCodeResponse';
import apiClient from './apiClient';

export const confirmCodeSmsCreate = (
  action: CodeValidatedActionEnum,
  phone: string,
  gRecaptchaCode: string
): Promise<SmsCodeResponse> => {
  const url = 'confirm-code/sms/create';
  return apiClient
    .post(url, {
      action,
      gRecaptchaCode,
      phone,
    })
    .then((r) => r.data)
    .catch((e) => {
      if (e.response) {
        if (e.response.status === 429) {
          const { resendAt, createdAt, expiredAt } = e.response.data;
          return {
            resendAt,
            createdAt,
            expiredAt,
          };
        }
      }
      throw e;
    });
};
